
import { ref, computed } from 'vue'
import * as utils from './utils.js'
import i18n from '@/assets/lang'
import { ElMessage } from 'element-plus'
import useClipboard from 'vue-clipboard3'

import * as api from '@/api/apiPayOrder/index'
import { Kernaldec } from '@/hooks/useDecrypt'
import * as api1 from '@/api/contactAccount/contact2.js'
import { useDemoStore } from '@/pinia/index'
const store = useDemoStore()
export const selectLoading = ref(false)
const pendingRequest = ref(true)
//下拉框展开关闭调用
export const cantPendingRequest = (val) => {
    if (!val) {
        pendingRequest.value = false
    } else {
        pendingRequest.value = true
    }
}
/************ 搜索获取产品列表开始 ************/
export const modelList = ref([])
const modelLastPage = ref('')
const modelData = { token: '', kw: '', page: '', pageSize: '10' }
export const getModel = () => {
    modelData.page = 1
    modelData.kw = ''
    modelList.value = null
    selectLoading.value = true
    modelData.token = store.token
    api.orderModel(modelData).then((res) => {
        selectLoading.value = false
        modelLastPage.value = res.data?.last_page
        modelList.value = res.data?.data?.map((item) => {
            item.label = item.model
            item.value = item.product_id
            item.weightUnit = item.weight_unit
            item.weight = item.weight
            return item
        })
    })
}
export const remoteModel = (val) => {
    utils.debounce(500, () => {
        if (modelData.kw == val || !pendingRequest.value) return false
        modelData.kw = val
        modelList.value = null
        selectLoading.value = true
        api.orderModel(modelData).then((res) => {
            selectLoading.value = false
            modelLastPage.value = res.data?.last_page
            modelList.value = res.data?.data?.map((item) => {
                item.label = item.model
                item.value = item.product_id
                item.weightUnit = item.weight_unit
                item.weight = item.weight
                return item
            })
        })
    })
}

export const getModel1 = () => {
    utils.debounce(500, () => {
        if (modelData.page == modelLastPage.value || modelList.value?.length == 0) return false
        modelData.page++
        api.orderModel(modelData).then((res) => {
            modelLastPage.value = res.data?.last_page
            modelList.value = [...modelList.value, ...res.data?.data?.map((item) => {
                item.label = item.model
                item.value = item.product_id
                return item
            })]
        })
    })
}
/************ 搜索获取产品列表结束 ************/
/************ 搜索获取产品品牌列表开始 ************/
export const brandList = ref([])
const brandData = { token: '', kw: '', page: '' }
export const getBrand = () => {
    brandData.kw = ''
    brandData.page = 1
    brandList.value = null
    selectLoading.value = true
    brandData.token = store.token
    api.orderBrand(brandData).then((res) => {
        selectLoading.value = false
        brandLastPage.value = res.data?.last_page
        brandList.value = res.data?.data?.map((item) => {
            item.label = item.brand_name
            item.value = item.brand_id
            return item
        })
    })
}
export const remoteBrand = (val) => {
    utils.debounce(500, () => {
        if (brandData.kw == val || !pendingRequest.value) return false
        brandData.kw = val
        brandList.value = null
        selectLoading.value = true
        api.orderBrand(brandData).then((res) => {
            selectLoading.value = false
            brandLastPage.value = res.data?.last_page
            brandList.value = res.data?.data?.map((item) => {
                item.label = item.brand_name
                item.value = item.brand_id
                return item
            })
        })
    })
}
const brandLastPage = ref('')
export const getBrand1 = () => {
    utils.debounce(500, () => {
        if (brandData.page == brandLastPage.value || brandList.value?.length == 0) return false
        brandData.page++
        api.orderBrand(brandData).then((res) => {
            brandLastPage.value = res.data?.last_page
            brandList.value = [...brandList.value, ...res.data?.data?.map((item) => {
                item.label = item.brand_name
                item.value = item.brand_id
                return item
            })]
        })
    })
}
/************ 搜索获取产品品牌列表结束 ************/
/************ 获取交期列表开始 ************/
export const leadingList = ref([])
export const getleading = () => {
    api.orderLeading({ token: store.token }).then((res) => {
        leadingList.value = res?.data
    })
}
/************ 获取交期列表结束 ************/

/**********获取货况列表开始**********/
export const conditionList = ref([])
export const getCondition = () => {
    api.orderCondition({ token: store.token }).then((res) => {
        conditionList.value = res?.data?.map(item => item.text)
    })
}
/**********获取货况列表结束**********/
/**********规格列表开始**********/
export const specList = ref([])
const specData = {
    token: '', page: '', pageSize: 30, product_id: '',
}
export const getSpecList = (row) => {
    specData.page = 1
    specList.value = null
    specData.token = store.token
    selectLoading.value = true
    specData.product_id = row.product_id
    api.ocGetSku(specData).then(res => {
        selectLoading.value = false
        specCondionLastPage.value = res.data?.list?.last_page
        specList.value = res.data?.list?.data?.map(item => {
            return {
                specs_id: item.specs_id,
                Spec: item.spec ? item.spec : '-'
            }
        })
    })
}

const specCondionLastPage = ref(0)
export const getSpecList1 = () => {
    if (specCondionLastPage.value == specData.page || specList.value?.length == 0) return false
    specData.page++
    api.ocGetSku(specData).then(res => {
        specCondionLastPage.value = res.data?.list?.last_page
        specList.value = [...specList.value, ...res.data?.list?.data?.map(item => {
            return {
                specs_id: item.specs_id,
                Spec: item.spec ? item.spec : '-'
            }
        })]
    })
}
/**********规格列表结束**********/
/************ 获取货币类型开始 ************/
export const currentList = ref([])
export const getCurrent = () => {
    api.ordersConfigCurrent({ token: store.token }).then(res => {
        currentList.value = res.data && res.data
    })
}
/************ 获取货币类型结束 ************/
/************ 获取用户列表开始 ************/
export const userList = ref([])
const userData = { page: '', limit: 10, from_id: '', keyword: '', company_id: '', customer_info_id: '' }
/**
 * 
 * @param  { Number } SaleID -对应ownerID
 * @param {Number} typeID  -调用组件传入的用于确定联系人模块具体调用位置 1、accounts  2、contacts
 * @param {Number} clientID -调用组件传入id (accounts=>客户id)(contacts=>联系人id)
 */
export const getUser = (SaleID, typeID, clientID) => {
    userData.page = 1
    userData.keyword = ''
    userData.from_id = SaleID
    selectLoading.value = true
    userData.company_id = typeID == 1 ? clientID : null //客户调用只传客户id
    userData.customer_info_id = typeID == 2 ? clientID : null //联系人调用只传联系人id
    api1.contactsOwner(userData).then((res) => {
        selectLoading.value = false
        userLastPage.value = res?.data?.contacts?.last_page
        userList.value = res?.data?.contacts?.list?.map((item) => {
            item.firstname = Kernaldec(item.firstname)
            item.lastname = Kernaldec(item.lastname)
            item.label = `${item.firstname}\u200B${item.lastname}`
            item.label = item.label?.length > 80 ? `${item.label?.slice(0, 80)}...` : item.label
            item.value = item.owners?.length && String(item.owners[0]?.contact_id)
            return item
        })
    })
}

export const remoteUser = (val) => {
    utils.debounce(500, () => {
        if (userData.keyword == val || !pendingRequest.value) return false
        userData.page = 1
        userData.keyword = val
        selectLoading.value = true
        api1.contactsOwner(userData).then((res) => {
            selectLoading.value = false
            userLastPage.value = res?.data?.contacts?.last_page
            userList.value = res?.data?.contacts?.list?.map((item) => {
                item.firstname = Kernaldec(item.firstname)
                item.lastname = Kernaldec(item.lastname)
                item.label = `${item.firstname}\u200B${item.lastname}`
                item.label = item.label?.length > 80 ? `${item.label?.slice(0, 80)}...` : item.label
                item.value = item.owners?.length && String(item.owners[0]?.contact_id)
                return item
            })
        })
    })
}
const userLastPage = ref('')
export const getUser1 = () => {
    utils.debounce(500, () => {
        if (userLastPage.value == userData.page || userList.value.length == 0) return false
        userData.page++
        api1.contactsOwner(userData).then((res) => {
            userLastPage.value = res?.data?.contacts?.last_page
            userList.value = [...userList.value, ...res?.data?.contacts?.list?.map((item) => {
                item.firstname = Kernaldec(item.firstname)
                item.lastname = Kernaldec(item.lastname)
                item.label = `${item.firstname}\u200B${item.lastname}`
                item.label = item.label?.length > 80 ? `${item.label?.slice(0, 80)}...` : item.label
                item.value = item.owners?.length && String(item.owners[0]?.contact_id)
                return item
            })]
        })
    })
}
/************ 获取用户列表结束 ************/
/************ 获取owner列表开始 ************/
export const groupList = ref([])
const ownerData = {
    page: '', limit: 1, keyword: '', is_help: 1,
    customer_info_id: '', company_id: ''
}
/**
 * 
 * @param  { Number } BuyerID -对应联系ID,通过此id查询对应绑定的责任人
 * @param { Number } typeID  -调用组件传入的用于确定联系人模块具体调用位置 1、accounts  2、contacts
 * @param { Number } clientID -调用组件传入id (accounts=>客户id)(contacts=>联系人id)
 */
export const getGroupList = (BuyerID, typeID, clientID) => {
    ownerData.page = 1
    ownerData.keyword = ''
    selectLoading.value = true
    ownerData.customer_info_id = BuyerID
    ownerData.company_id = typeID == 1 ? clientID : null
    api1.contactsOwner(ownerData).then((res) => {
        selectLoading.value = false
        groupList.value = res.data?.owners?.map(item => {
            return { value: String(item.owner_id), label: Kernaldec(item.user_name) }
        })
    })
}

export const remoteGroupList = (val) => {
    utils.debounce(500, () => {
        if (ownerData.keyword == val || !pendingRequest.value) return false
        selectLoading.value = true
        ownerData.keyword = val
        api1.contactsOwner(ownerData).then((res) => {
            selectLoading.value = false
            groupList.value = res.data?.owners?.map(item => {
                return { value: String(item.owner_id), label: Kernaldec(item.user_name) }
            })
        })
    })
}
/************ 获取owner列表结束 ************/

/************ 内外部fromOrder&&售后补发单获取order列表开始 ************/
export const orderIDList = ref([])
const orderIDdata = {
    token: '', kw: '', page: '', pageSize: 20,
    status: '', from_orders: '', PI_type: '', source: ''
}
/**
 * 
 * @param  { Number } state -状态：0-所有，1-待开始，2-进行中，3-已完成
 * @param { Number } type -订单类型：0-所有，1-普通，2-佣金单，3-售后补发单
 * @param { Number } fromOrder  -来自订单
 * @param { Number } source  -财务售后'payment'
 */
export const getOrderIDList = (state, type, fromOrder, source) => {
    orderIDdata.kw = ''
    orderIDdata.page = 1
    orderIDdata.status = state
    orderIDdata.PI_type = type
    orderIDdata.token = store.token
    orderIDdata.from_orders = fromOrder
    orderIDdata.source = source
    orderIDList.value = null
    selectLoading.value = true
    api.oederidList(orderIDdata).then((res) => {
        selectLoading.value = false
        orderIDList.value = res.data?.data
        orderLastPage.value = res.data?.last_page
    })
}

export const remoteOrderIDList = (val) => {
    utils.debounce(500, () => {
        if (orderIDdata.kw == val || !pendingRequest.value) return false
        selectLoading.value = true
        orderIDList.value = null
        orderIDdata.kw = val
        api.oederidList(orderIDdata).then((res) => {
            selectLoading.value = false
            orderIDList.value = res.data?.data
            orderLastPage.value = res.data?.last_page
        })
    })
}

const orderLastPage = ref(0)
export const getOrderIDList1 = () => {
    if (orderIDdata.page == orderLastPage.value || orderIDList.value?.length == 0) return false
    utils.debounce(100, () => {
        orderIDdata.page++
        api.oederidList(orderIDdata).then((res) => {
            orderLastPage.value = res.data?.last_page
            orderIDList.value = [...orderIDList.value, ...res.data?.data]
        })
    })
}
/************ fromOrder&&售后补发单获取order列表开始 ************/
/************ fromQtn获取Qtn列表开始 ************/
export const qtnIDList = ref([])
const qtnIDdata = { token: '', inquiry_id: '', page: '', pageSize: 10 }
export const getQtnIDList = (val) => {
    qtnIDdata.token = store.token
    selectLoading.value = true
    qtnIDdata.inquiry_id = ''
    qtnIDList.value = null
    qtnIDdata.page = 1
    api.ocGetInquiry(qtnIDdata).then((res) => {
        selectLoading.value = false
        qtnLastPage.value = res.data?.last_page
        qtnIDList.value = res.data?.data?.map(item => {
            item.label = `${item.inquiry_id} (${item.rfq_type})`
            return item
        })
    })
}

export const remoteQtnIDList = (val) => {
    utils.debounce(500, () => {
        if (qtnIDdata.inquiry_id == val || !pendingRequest.value) return false
        selectLoading.value = true
        qtnIDdata.inquiry_id = val
        qtnIDList.value = null
        api.ocGetInquiry(qtnIDdata).then((res) => {
            selectLoading.value = false
            qtnLastPage.value = res.data?.last_page
            qtnIDList.value = res.data?.data?.map(item => {
                item.label = `${item.inquiry_id} (${item.rfq_type})`
                return item
            })
        })
    })
}

const qtnLastPage = ref(0)
export const getQtnIDList1 = () => {
    if (qtnIDdata.page == qtnLastPage.value || qtnIDList.value?.length == 0) return false
    utils.debounce(100, () => {
        qtnIDdata.page++
        api.ocGetInquiry(qtnIDdata).then((res) => {
            qtnLastPage.value = res.data?.last_page
            qtnIDList.value = [...qtnIDList.value, ...res.data?.data?.map(item => {
                item.label = `${item.inquiry_id} (${item.rfq_type})`
                return item
            })]
        })
    })
}
/************ fromQtn获取Qtn列表结束 ************/
/**********订单来源数据开始**********/
export const orderFromList = ref([])
const orderFromData = {
    token: '', source: '', keyword: '', page: '', paheSize: 30,
}
/**
 * 
 * @param {String} source -调用模块orders-销售订单，purchaseordertask-采购任务，purchaseorder-采购订单，payment-财务
 */
export const getOrderFromList = (source) => {
    orderFromData.token = store.token
    orderFromData.source = source
    orderFromData.keyword = ''
    orderFromData.page = 1
    orderFromList.value = null
    selectLoading.value = true
    api.ocFromType(orderFromData).then(res => {
        selectLoading.value = false
        orderFromList.value = res.data?.list?.data
        orderFromListLastPage.value = res.data?.list?.last_page
    })
}
export const remoteOrderFromList = (val) => {
    utils.debounce(500, () => {
        if (orderFromData.keyword == val || !pendingRequest.value) return false
        orderFromData.keyword = val
        orderFromData.page = 1
        orderFromList.value = null
        selectLoading.value = true
        api.ocFromType(orderFromData).then(res => {
            selectLoading.value = false
            orderFromList.value = res.data?.list?.data
            orderFromListLastPage.value = res.data?.list?.last_page
        })
    })

}
const orderFromListLastPage = ref(0)
export const getOrderFromList1 = () => {
    utils.debounce(500, () => {
        if (orderFromData.page == orderFromListLastPage.value || orderFromList.value?.length == 0) return false
        orderFromData.page++
        api.ocFromType(orderFromData).then(res => {
            orderFromList.value = [...orderFromList.value, ...res.data?.list?.data]
        })
    })
}
/**********订单来源数据结束**********/
/**********采购单列表、采购单详情、售后补发单获取用户开始**********/
export const crmUserList = ref([])
const crmUserLastPage = ref(0)
const crmUserData = { token: '', kw: '', group: '', source: '', page: '', pageSize: 30 }
/**
 * 
 * @param  { Number } type -用户分组：0-所有 1-销售 2-采购 3-客户 4-总务
 * @param  { Number } source -orders-销售订单，purchaseordertask-采购任务，purchaseorder-采购订单，payment-财务
 */
export const getCrmUserList = (type, source) => {
    crmUserData.kw = ''
    crmUserData.page = 1
    crmUserData.group = type
    crmUserList.value = null
    selectLoading.value = true
    crmUserData.source = source
    crmUserData.token = store.token
    api.ordersConfigGetUser(crmUserData).then((res) => {
        selectLoading.value = false
        crmUserLastPage.value = res.data?.last_page
        crmUserList.value = res.data?.data
    })
}

export const remoteCrmUserList = (val) => {
    utils.debounce(500, () => {
        if (crmUserData.kw == val || !pendingRequest.value) return false
        crmUserData.kw = val
        crmUserData.page = 1
        crmUserList.value = null
        selectLoading.value = true
        api.ordersConfigGetUser(crmUserData).then((res) => {
            selectLoading.value = false
            crmUserLastPage.value = res.data?.last_page
            crmUserList.value = res.data?.data
        })
    })
}

export const getCrmUserList1 = () => {
    utils.debounce(500, () => {
        if (crmUserData.page == crmUserLastPage.value || crmUserList.value?.length == 0) return false
        crmUserData.page++
        api.ordersConfigGetUser(crmUserData).then((res) => {
            crmUserLastPage.value = res.data?.last_page
            crmUserList.value = [...crmUserList.value, ...res.data?.data]
        })
    })
}
/**********采购单列表、采购单详情、售后补发单获取用户结束**********/
/**********售后补发单获取用户开始**********/
export const undertakerList = ref([])
const undertakerData = { token: '', kw: '', page: '', pageSize: 30 }
export const getOrdersUndertaker = () => {
    undertakerData.kw = ''
    undertakerData.page = 1
    undertakerList.value = null
    undertakerData.token = store.token
    api.ordersUndertaker(undertakerData).then(res => {
        undertakerLastPage.value = res.data?.last_page
        undertakerList.value = res.data?.data
    })
}
export const remoteOrdersUndertaker = (val) => {
    utils.debounce(500, () => {
        if (undertakerData.kw == val || !pendingRequest.value) return false
        undertakerData.kw = val
        undertakerData.page = 1
        undertakerList.value = null
        api.ordersUndertaker(undertakerData).then(res => {
            undertakerLastPage.value = res.data?.last_page
            undertakerList.value = res.data?.data
        })
    })
}
const undertakerLastPage = ref(0)
export const getOrdersUndertaker1 = () => {
    utils.debounce(500, () => {
        if (undertakerData.page == undertakerLastPage.value || undertakerList.value?.length == 0) return false
        undertakerData.page++
        api.ordersUndertaker(undertakerData).then(res => {
            undertakerLastPage.value = res.data?.last_page
            undertakerList.value = [...undertakerList.value, ...res.data?.data]
        })
    })
}
/**********售后补发单获取用户结束**********/
/************ 内部销售单列表、新增银行，新增地址获取国家列表开始 ************/
export const countryList = ref([])
const countryData = { token: '', name: '', rows: 30, page: '' }
export const getCountry = () => {
    countryData.token = store.token
    selectLoading.value = true
    countryList.value = null
    countryData.page = 1
    countryData.name = ''
    api.ordersConfigCountry(countryData).then(res => {
        selectLoading.value = false
        countryLastPage.value = res.data?.last_page
        countryList.value = res.data?.data?.map(item => {
            return { label: item.name, value: item.country_id }
        })
    })
}
export const remoteCountry = (val) => {
    utils.debounce(500, () => {
        if (countryData.name == val || !pendingRequest.value) return false
        selectLoading.value = true
        countryList.value = null
        countryData.name = val
        api.ordersConfigCountry(countryData).then(res => {
            selectLoading.value = false
            countryLastPage.value = res.data?.last_page
            countryList.value = res.data?.data?.map(item => {
                return { label: item.name, value: item.country_id }
            })
        })
    })
}
const countryLastPage = ref('')
export const getCountry1 = () => {
    utils.debounce(500, () => {
        if (countryData.page == countryLastPage.value || countryList.value?.length == 0) return false
        api.ordersConfigCountry(countryData).then(res => {
            countryLastPage.value = res.data?.last_page
            countryList.value = [...countryList.value, ...res.data?.data?.map(item => {
                return { label: item.name, value: item.country_id }
            })]
        })
    })
}
/************ 内部销售单列表、新增银行，新增地址获取国家列表结束 ************/
/************ 获取客户和供应商列表开始 ************/
export const clentAndSupperList = ref([])
const clentAndSupperdata = {
    token: '', kw: '', user_id: '',
    is_supplier: '', search_use: '', page: '',
}
/**
 * 
 * @param  { Number } isType -是否为供应商 1-是 0-否
 * @param {Number} isNav  -是否搜索栏使用：1-是，0-否
 * @param {Number} userID  -采购id获取某一用户绑定的供应商
 */
export const getClentAndSupper = (isType, isNav, userID) => {
    selectLoading.value = true
    clentAndSupperdata.kw = ''
    clentAndSupperdata.page = 1
    clentAndSupperList.value = null
    clentAndSupperdata.user_id = userID
    clentAndSupperdata.search_use = isNav
    clentAndSupperdata.is_supplier = isType
    clentAndSupperdata.token = store.token
    api.orderUser(clentAndSupperdata).then((res) => {
        selectLoading.value = false
        clentAndSupperLastPage.value = res?.data?.last_page
        clentAndSupperList.value = res.data?.data ? res?.data?.data?.map((item) => {
            item.firstname = Kernaldec(item.firstname)
            item.lastname = Kernaldec(item.lastname)
            item.label = `${item.firstname}${item.lastname}`
            item.value = item.customer_info_id
            return item
        }) : []
    })
}
export const remoteClentAndSupper = (val) => {
    utils.debounce(500, () => {
        if (clentAndSupperdata.kw == val || !pendingRequest.value) return false
        selectLoading.value = true
        clentAndSupperList.value = null
        clentAndSupperdata.kw = val
        api.orderUser(clentAndSupperdata).then((res) => {
            selectLoading.value = false
            clentAndSupperLastPage.value = res?.data?.last_page
            clentAndSupperList.value = res.data?.data ? res?.data?.data?.map((item) => {
                item.firstname = Kernaldec(item.firstname)
                item.lastname = Kernaldec(item.lastname)
                item.label = `${item.firstname}${item.lastname}`
                item.value = item.customer_info_id
                return item
            }) : []
        })
    })
}

const clentAndSupperLastPage = ref('')
export const getClentAndSupper1 = () => {
    utils.debounce(500, () => {
        if (clentAndSupperLastPage.value == clentAndSupperdata.page || clentAndSupperList.value?.length == 0) return false
        clentAndSupperdata.page++
        api.orderUser(clentAndSupperdata).then((res) => {
            clentAndSupperLastPage.value = res?.data?.last_page
            clentAndSupperList.value = [...clentAndSupperList.value, ...res?.data?.data?.map((item) => {
                item.firstname = Kernaldec(item.firstname)
                item.lastname = Kernaldec(item.lastname)
                item.label = `${item.firstname}${item.lastname}`
                item.value = item.customer_info_id
                return item
            })]
        })
    })
}
/************ 获取客户和供应商列表结束 ************/

/************ 获取客户采购单客户销售单编辑新建，fromPurcharseOrder弹窗 ************/
export const pOrderIDList = ref([]) // 采购单列表
const pOrderIDdata = { token: '', order_number: "", page: "", pageSize: 30 }
export const getPorderIDList = (val) => {
    selectLoading.value = true
    pOrderIDdata.page = 1
    pOrderIDList.value = null
    pOrderIDdata.order_number = ""
    pOrderIDdata.token = store.token
    api.ocGetCustomerOrders(pOrderIDdata).then((res) => {
        selectLoading.value = false
        pOrderLastPage.value = res.data?.list?.last_page
        pOrderIDList.value = res.data?.list?.data
    })
}
export const remotePorderIDList = (val) => {
    utils.debounce(500, () => {
        if (orderIDdata.order_number == val || !pendingRequest.value) return false
        selectLoading.value = true
        pOrderIDList.value = null
        pOrderIDdata.page = 1
        orderIDdata.order_number = val
        api.ocGetCustomerOrders(orderIDdata).then((res) => {
            selectLoading.value = false
            pOrderLastPage.value = res.data?.list?.last_page
            pOrderIDList.value = res.data?.list?.data
        })
    })
}
const pOrderLastPage = ref(0)
export const getPorderIDList1 = (val) => {
    utils.debounce(500, () => {
        if (pOrderLastPage.value == pOrderIDdata.page || pOrderIDList.value?.length == 0) return false
        pOrderIDdata.page++
        api.ocGetCustomerOrders(pOrderIDdata).then((res) => {
            pOrderLastPage.value = res.data?.list?.last_page
            pOrderIDList.value = [...pOrderIDList.value, ...res.data?.list?.data]
        })
    })
}
/************ 获取客户采购单客户销售单编辑新建，fromPurcharseOrder弹窗 ************/
/************ 客户银行获取通用方法开始 ************/
export const bankList = ref([])
export const getBankList = (val) => {
    api.orderPayment({ token: store.token }).then(res => {
        bankList.value = res.data?.map(item => {
            item.bank_info1 = `${item.bank_name}${item.bank_info}(${item.currency})${item.account}${item.company_name}`
            return item
        })
    })
}
/************ 客户银行获取通用方法结束 ************/

/************ 客户采购单获取owner和采购方通用方法开始 ************/
export const clientGroupList = ref([])// 获取团队
export const clientUsetList = ref([])
const clientOwnerData = { token: '', kw: "", page: "", pageSize: 50 }
export const getClientGroupList = () => {
    selectLoading.value = true
    clientOwnerData.kw = ''
    clientOwnerData.page = 1
    clientOwnerData.token = store.token
    api.cpoGetUser(clientOwnerData).then(res => {
        selectLoading.value = false
        clentLastPage.value = res?.data?.contacts?.last_page
        clientUsetList.value = res.data?.data?.map(item => {
            return { value: String(item.id), label: Kernaldec(item.name) }
        })
        clientGroupList.value = res.data?.data?.map(item => {
            return { value: String(item.id), label: Kernaldec(item.name) }
        })
    })
}
export const remoteClientGroupList = (val) => {
    utils.debounce(500, () => {
        if (clientOwnerData.kw == val || !pendingRequest.value) return false
        selectLoading.value = true
        clientOwnerData.kw = val
        clientOwnerData.page = 1
        api.cpoGetUser(clientOwnerData).then((res) => {
            selectLoading.value = false
            clentLastPage.value = res?.data?.contacts?.last_page
            clientUsetList.value = res.data?.data?.map(item => {
                return { value: String(item.id), label: Kernaldec(item.name) }
            })
            clientGroupList.value = res.data?.data?.map(item => {
                return { value: String(item.id), label: Kernaldec(item.name) }
            })
        })
    })
}
const clentLastPage = ref(0)
export const getClientGroupList1 = (val) => {
    utils.debounce(500, () => {
        if (clientOwnerData.page == clentLastPage.value || clientGroupList.value.length == 0) return false
        clientOwnerData.page++
        api.cpoGetUser(clientOwnerData).then(res => {
            clentLastPage.value = res?.data?.contacts?.last_page
            clientUsetList.value = [...clientGroupList.value, ...res.data?.data?.map(item => {
                return { value: String(item.id), label: Kernaldec(item.name) }
            })]
            clientGroupList.value = [...clientGroupList.value, ...res.data?.data?.map(item => {
                return { value: String(item.id), label: Kernaldec(item.name) }
            })]
        })
    })
}
/************ 客户采购单获取owner和采购方通用方法结束 ************/

/**********获取常用时间开始**********/
export const shortcuts = computed(() => {
    return [{
        text: i18n.global.t('Order.orderPast7Days'),
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            return [start, end]
        },
    }, {
        text: i18n.global.t('Order.orderPast30Days'),
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            return [start, end]
        },
    }, {
        text: i18n.global.t('Order.orderPast90Days'),
        value: () => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            return [start, end]
        },
    }]
})
/**********获取常用时间结束**********/
/**********复制型号和品牌公共方法开始**********/
const { toClipboard } = useClipboard(); //剪切板
const copyInfo = ref('')
export const copyText = (info) => {
    copyInfo.value = info
    try {
        toClipboard(copyInfo.value)
        ElMessage({ message: i18n.global.t('Order.orderReplication'), type: 'success' })
    } catch (e) {
        console.error(e)
    }
}
/**********复制型号和品牌公共方法结束**********/

